import Dropdown from 'bootstrap/js/src/dropdown';
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['toggle'];
  static values = { popperStrategy: String };

  connect() {
    if (!this.popperStrategyValue || !this.hasToggleTarget) return;

    // When the dropdown lives inside a container that clips overflow
    // (e.g. a Tabulator cell), Popper's default `position: absolute`
    // menu is cropped at the container's edge. `strategy: 'fixed'`
    // positions relative to the viewport so the menu escapes any
    // `overflow: hidden|auto` ancestor.
    //
    // We instantiate the Dropdown here so we can pass popperConfig;
    // Bootstrap's data-API click handler (auto-init) calls
    // `Dropdown.getOrCreateInstance`, which finds our pre-built
    // instance and reuses it — so toggling and the global "close on
    // outside click" handler (which queries `[data-bs-toggle="dropdown"]`)
    // both keep working without any extra wiring on our side.
    Dropdown.getOrCreateInstance(this.toggleTarget, {
      popperConfig: (config) => ({
        ...config,
        strategy: this.popperStrategyValue,
      }),
    });
  }

  disconnect() {
    if (!this.hasToggleTarget) return;

    Dropdown.getInstance(this.toggleTarget)?.hide();
  }

  close() {
    if (!this.hasToggleTarget) return;

    Dropdown.getInstance(this.toggleTarget)?.hide();
  }
}
